// import React, { useEffect, useState } from "react";
// import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
// import WorkIcon from '@mui/icons-material/Work';
// import RocketIcon from '@mui/icons-material/Rocket';
// import BookIcon from '@mui/icons-material/Book';
// import { Fade } from "react-awesome-reveal";
// import api from "../services/httpService";
// import "../pages/about.css";

// import Footer from "./main/footer";
// import Navbar from "../components/Navbar";

// const Aboutpage = () => {
//   const [sections, setSections] = useState([]);

//   useEffect(() => {
//     loadAbout();
//   }, []);

//   const loadAbout = async () => {
//     try {
//       const res = await api.get("/sentinix/aboutsections");
//       setSections(res.data.data || []);
//     } catch (err) {
//       console.error("Failed to load about sections", err);
//     }
//   };

//   const getSection = (type) => sections.find((s) => s.sectionType === type);

//   const getImage = (section) => {
//     if (!section?.imageKey) return "";
//     if (typeof section.imageKey === "string") return section.imageKey;
//     if (Array.isArray(section.imageKey)) return section.imageKey[0];
//     return "";
//   };

//  const renderParagraphs = (text) => {
//   if (!text) return null;
  
//   const paragraphs = text
//     .split(/\n\n|\n/)
//     .map((p) => p.trim())
//     .filter((p) => p.length > 0);

//   return paragraphs.map((para, index) => (
//     <Typography
//       key={index}
//       sx={{
//         textAlign: "justify",
//         fontSize: { xs: "14px", sm: "15px", md: "16px" },
//         lineHeight: 1.8,
//         mb: 2,
//       }}
//     >
//       {para}
//     </Typography>
//   ));
// };

//   return (
//     <>
//       <Navbar />
//       <div className="aboutpage-container">

//         {/* ================= BANNER ================= */}
//         <Box className="aboutban_imgg">
//           <img src={getImage(getSection("hero"))} alt="About Banner" />
//         </Box>

//         {/* ================= ABOUT US ================= */}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: { xs: "column", md: "row" },
//             alignItems: "center",
//             justifyContent: "center",
//             height: { xs: "auto", md: "90vh" },
//             pt: 5,
//             px: { xs: 2, md: 4 },
//           }}
//         >
//           {/* Image */}
//           <Grid
//             item
//             md={6}
//             xs={12}
//             className="image-section"
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               mb: { xs: 3, md: 0 },
//             }}
//           >
//             <Fade duration={1000}>
//               <img
//                 src={getImage(getSection("about-us"))}
//                 alt="IT services provider"
//                 style={{ width: "100%", height: "100%", objectFit: "contain" }}
//               />
//             </Fade>
//           </Grid>

//           {/* Text */}
//           <Grid
//             item
//             md={6}
//             xs={12}
//             className="text-section"
//             sx={{
//               textAlign: { xs: "center", md: "justify" },
//               px: { xs: 2, md: 4 },
//               py: { xs: 3, md: 0 },
//             }}
//           >
//             <Fade duration={1500}>
//               <Box>
//                 <Typography
//                   variant="h4"
//                   sx={{
//                     color: "darkgreen",
//                     fontWeight: 550,
//                     fontSize: { xs: "24px", sm: "28px", md: "32px" },
//                     textAlign: { xs: "center", md: "left" },
//                     mb: 2,
//                   }}
//                 >
//                   {getSection("about-us")?.title}
//                 </Typography>
//                 {renderParagraphs(getSection("about-us")?.description)}
//               </Box>
//             </Fade>
//           </Grid>
//         </Box>

//         {/* ================= WHY CHOOSE US ================= */}
//         <Box
//           sx={{
//             width: "100%",
//             px: { xs: 2, md: 5 },
//             py: 5,
//             display: "flex",
//             flexDirection: { xs: "column", md: "row" },
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             gap: { xs: 4, md: 3 },
//           }}
//         >
//           {/* Left: Title + Description */}
//           <Box sx={{ flex: { xs: "100%", md: "55%" }, px: { xs: 0, sm: 1 } }}>
//             <Fade duration={1000} delay={1000} triggerOnce>
//               <Typography
//                 variant="h5"
//                 sx={{
//                   color: "darkgreen",
//                   fontWeight: 600,
//                   fontSize: { xs: "22px", sm: "24px", md: "28px", lg: "30px" },
//                   textAlign: "justify",
//                   mb: 2,
//                 }}
//               >
//                 {getSection("why-choose-us")?.title}
//               </Typography>
//               <Box sx={{ marginRight: { xs: 0, sm: 4 } }}>
//                 {renderParagraphs(getSection("why-choose-us")?.description)}
//               </Box>
//             </Fade>
//           </Box>

//           {/* Right: Vision + Mission + Values cards */}
//           <Box
//             sx={{
//               width: "80%",
//               display: "flex",
//               flexDirection: { xs: "column", md: "row" },
//               justifyContent: "space-between",
//               alignItems: "stretch",
//               gap: { xs: 4, md: 3 },
//               px: { xs: 2, md: 5 },
//               py: 5,
//             }}
//           >
//             {/* Content1 + Content2 column */}
//             <Box
//               sx={{
//                 flex: { xs: "100%", md: "50%" },
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 4,
//               }}
//             >
//               {/* Content 1 — Vision */}
//               <Fade duration={1000} delay={500} triggerOnce>
//                 <Card sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }} className="card-con">
//                   <CardContent>
//                     <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
//                       <div className="our-values">
//                       <RocketIcon sx={{ color: '#fff', fontSize: 40 }} />
//                       </div>
//                     </Box>
//                     <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 1 }}>
//                       {getSection("content1")?.title}
//                     </Typography>
//                     <Typography variant="body2" align="justify" sx={{ fontSize: "15px", lineHeight: 1.8 }}>
//                       {getSection("content1")?.description}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Fade>

//               {/* Content 2 — Mission */}
//               <Fade duration={1000} delay={1000} triggerOnce>
//                 <Card sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }} className="card-con">
//                   <CardContent>
//                     <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
//                       <div className="our-values">
//                          <WorkIcon sx={{ color: '#fff', fontSize: 40 }} />
//                       </div>
//                     </Box>
//                     <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 1 }}>
//                       {getSection("content2")?.title}
//                     </Typography>
//                     <Typography variant="body2" align="justify" sx={{ fontSize: "15px", lineHeight: 1.8 }}>
//                       {getSection("content2")?.description}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Fade>
//             </Box>

//             {/* Content 3 — Values */}
//             <Box
//               sx={{
//                 flex: { xs: "100%", md: "45%" },
//                 display: "flex",
//                 alignItems: "center",
//                 ml: { xs: 0, md: -1 },
//               }}
//             >
//               <Fade duration={1000} delay={1500} triggerOnce>
//                 <Card sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }} className="card-con">
//                   <CardContent>
//                     <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
//                       <div className="our-values">
//                          <BookIcon sx={{ color: '#fff', fontSize: 40 }} />
//                       </div>
//                     </Box>
//                     <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 1 }}>
//                       {getSection("content3")?.title}
//                     </Typography>
//                     <Typography variant="body2" align="justify" sx={{ fontSize: "15px", lineHeight: 1.8 }}>
//                       {getSection("content3")?.description}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Fade>
//             </Box>
//           </Box>
//         </Box>

//         <Footer />
//       </div>
//     </>
//   );
// };

// export default Aboutpage;

import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import WorkIcon from '@mui/icons-material/Work';
import RocketIcon from '@mui/icons-material/Rocket';
import BookIcon from '@mui/icons-material/Book';
import { Fade } from "react-awesome-reveal";
import api from "../services/httpService";
import "../pages/about.css";

import Footer from "./main/footer";
import Navbar from "../components/Navbar";

const Aboutpage = () => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    loadAbout();
    fetchThemeColors();
  }, []);

  const fetchThemeColors = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const latest = allData.sort((a, b) => b.id - a.id)[0];

        if (latest) {
          const color1 = latest.color1 || "#f83600";
          const color2 = latest.color2 || "#fe8c00";
          
          document.documentElement.style.setProperty("--theme-color1", color1);
          document.documentElement.style.setProperty("--theme-color2", color2);
        }
      }
    } catch (err) {
      console.error("Error fetching theme colors:", err);
    }
  };

  const loadAbout = async () => {
    try {
      const res = await api.get("/sentinix/aboutsections");
      setSections(res.data.data || []);
    } catch (err) {
      console.error("Failed to load about sections", err);
    }
  };

  const getSection = (type) => sections.find((s) => s.sectionType === type);

  const getImage = (section) => {
    if (!section?.imageKey) return "";
    if (typeof section.imageKey === "string") return section.imageKey;
    if (Array.isArray(section.imageKey)) return section.imageKey[0];
    return "";
  };

  const renderParagraphs = (text) => {
    if (!text) return null;
    
    const paragraphs = text
      .split(/\n\n|\n/)
      .map((p) => p.trim())
      .filter((p) => p.length > 0);

    return paragraphs.map((para, index) => (
      <Typography
        key={index}
        sx={{
          textAlign: "justify",
          fontSize: { xs: "14px", sm: "15px", md: "16px" },
          lineHeight: 1.8,
          mb: 2,
          color: "#444"
        }}
      >
        {para}
      </Typography>
    ));
  };

  return (
    <>
      <Navbar />
      <div className="aboutpage-container">

        {/* ================= BANNER ================= */}
        <Box className="aboutban_imgg">
          <img src={getImage(getSection("hero"))} alt="About Banner" />
        </Box>

        {/* ================= ABOUT US ================= */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            minHeight: { xs: "auto", md: "90vh" },
            pt: 5,
            px: { xs: 2, md: 4 },
          }}
        >
          {/* Image */}
          <Grid
            item
            md={6}
            xs={12}
            className="image-section"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: { xs: 3, md: 0 },
            }}
          >
            <Fade duration={1000}>
              <img
                src={getImage(getSection("about-us"))}
                alt="IT services provider"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </Fade>
          </Grid>

          {/* Text */}
          <Grid
            item
            md={6}
            xs={12}
            className="text-section"
            sx={{
              textAlign: { xs: "center", md: "justify" },
              px: { xs: 2, md: 4 },
              py: { xs: 3, md: 0 },
            }}
          >
            <Fade duration={1500}>
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    fontWeight: 550,
                    fontSize: { xs: "24px", sm: "28px", md: "32px" },
                    textAlign: { xs: "center", md: "left" },
                    mb: 2,
                  }}
                >
                  {getSection("about-us")?.title}
                </Typography>
                {renderParagraphs(getSection("about-us")?.description)}
              </Box>
            </Fade>
          </Grid>
        </Box>

        {/* ================= WHY CHOOSE US ================= */}
        <Box
          sx={{
            width: "100%",
            px: { xs: 2, md: 5 },
            py: 5,
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: { xs: 4, md: 3 },
          }}
        >
          {/* Left: Title + Description */}
          <Box sx={{ flex: { xs: "100%", md: "55%" }, px: { xs: 0, sm: 1 } }}>
            <Fade duration={1000} delay={1000} triggerOnce>
              <Typography
                variant="h5"
                sx={{
                  background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  fontWeight: 600,
                  fontSize: { xs: "22px", sm: "24px", md: "28px", lg: "30px" },
                  textAlign: "justify",
                  mb: 2,
                }}
              >
                {getSection("why-choose-us")?.title}
              </Typography>
              <Box sx={{ marginRight: { xs: 0, sm: 4 } }}>
                {renderParagraphs(getSection("why-choose-us")?.description)}
              </Box>
            </Fade>
          </Box>

          {/* Right: Vision + Mission + Values cards */}
          <Box
            sx={{
              width: "80%",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: "stretch",
              gap: { xs: 4, md: 3 },
              px: { xs: 2, md: 5 },
              py: 5,
            }}
          >
            {/* Content1 + Content2 column */}
            <Box
              sx={{
                flex: { xs: "100%", md: "50%" },
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              {/* Content 1 — Vision */}
              <Fade duration={1000} delay={500} triggerOnce>
                <Card sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }} className="card-con">
                  <CardContent>
                    <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
                      <div className="our-values" style={{ background: `linear-gradient(135deg, var(--theme-color1), var(--theme-color2))` }}>
                        <RocketIcon sx={{ color: '#fff', fontSize: 40 }} />
                      </div>
                    </Box>
                    <Typography variant="h6" align="center" sx={{ 
                      fontWeight: 600, 
                      mb: 1,
                      background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}>
                      {getSection("content1")?.title}
                    </Typography>
                    <Typography variant="body2" align="justify" sx={{ fontSize: "15px", lineHeight: 1.8, color: "#444" }}>
                      {getSection("content1")?.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Fade>

              {/* Content 2 — Mission */}
              <Fade duration={1000} delay={1000} triggerOnce>
                <Card sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }} className="card-con">
                  <CardContent>
                    <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
                      <div className="our-values" style={{ background: `linear-gradient(135deg, var(--theme-color1), var(--theme-color2))` }}>
                        <WorkIcon sx={{ color: '#fff', fontSize: 40 }} />
                      </div>
                    </Box>
                    <Typography variant="h6" align="center" sx={{ 
                      fontWeight: 600, 
                      mb: 1,
                      background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}>
                      {getSection("content2")?.title}
                    </Typography>
                    <Typography variant="body2" align="justify" sx={{ fontSize: "15px", lineHeight: 1.8, color: "#444" }}>
                      {getSection("content2")?.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Fade>
            </Box>

            {/* Content 3 — Values */}
            <Box
              sx={{
                flex: { xs: "100%", md: "45%" },
                display: "flex",
                alignItems: "center",
                ml: { xs: 0, md: -1 },
              }}
            >
              <Fade duration={1000} delay={1500} triggerOnce>
                <Card sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }} className="card-con">
                  <CardContent>
                    <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
                      <div className="our-values" style={{ background: `linear-gradient(135deg, var(--theme-color1), var(--theme-color2))` }}>
                        <BookIcon sx={{ color: '#fff', fontSize: 40 }} />
                      </div>
                    </Box>
                    <Typography variant="h6" align="center" sx={{ 
                      fontWeight: 600, 
                      mb: 1,
                      background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}>
                      {getSection("content3")?.title}
                    </Typography>
                    <Typography variant="body2" align="justify" sx={{ fontSize: "15px", lineHeight: 1.8, color: "#444" }}>
                      {getSection("content3")?.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Fade>
            </Box>
          </Box>
        </Box>

        <Footer />
      </div>
    </>
  );
};

export default Aboutpage;